const rankingItems = [
  { rank: 1, title: '《迷雾追踪》', meta: '悬疑剧 · 8.7分', hot: '今日最热', trend: 'up' },
  { rank: 2, title: '《星际迷航：新纪元》', meta: '科幻片 · 8.6分', hot: '新片上榜', trend: 'up' },
  { rank: 3, title: '《深夜食堂》第七季', meta: '剧情剧 · 9.1分', hot: '连冠3天', trend: 'same' },
  { rank: 4, title: '《欢乐喜剧人》新季', meta: '综艺 · 8.9分', hot: '飙升最快', trend: 'up' },
  { rank: 5, title: '《江南烟雨》', meta: '年代剧 · 8.7分', hot: '口碑攀升', trend: 'up' },
  { rank: 6, title: '《密室逃脱》第五季', meta: '综艺 · 8.9分', hot: '稳定热播', trend: 'same' },
  { rank: 7, title: '《动物星球》特辑', meta: '纪录片 · 9.4分', hot: '高分推荐', trend: 'new' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            热播榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            实时热度排行，发现大家都在看的热门内容
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden">
            {rankingItems.map((item, idx) => (
              <a
                key={idx}
                href="#"
                className={`flex items-center gap-4 px-5 md:px-6 py-4 hover:bg-primary-50/50 transition-colors cursor-pointer ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-100' : ''
                }`}
              >
                <div className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg font-heading text-sm font-bold ${
                  item.rank === 1 ? 'bg-accent-500 text-background-50' :
                  item.rank === 2 ? 'bg-primary-500 text-background-50' :
                  item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                  'bg-background-100 text-foreground-500'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 truncate">
                      {item.title}
                    </h3>
                    {item.trend === 'up' && (
                      <i className="ri-arrow-up-fill text-accent-500 text-xs"></i>
                    )}
                    {item.trend === 'new' && (
                      <span className="text-[10px] px-1.5 py-0.5 rounded bg-accent-100 text-accent-600 font-medium">NEW</span>
                    )}
                  </div>
                  <p className="text-xs text-foreground-400 mt-0.5">{item.meta}</p>
                </div>
                <span className="flex-shrink-0 text-xs text-foreground-400 whitespace-nowrap">{item.hot}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}